import React, { Suspense, useEffect } from "react";
import { IconButton, Typography } from "@mui/material";
import JumboVerticalNavbar from "@jumbo/components/JumboVerticalNavbar/JumboVerticalNavbar";
import { DrawerHeader } from "@jumbo/components/JumboLayout/style";
import JumboScrollbar from "@jumbo/components/JumboScrollbar";
import useJumboLayoutSidebar from "@jumbo/hooks/useJumboLayoutSidebar";
import useJumboSidebarTheme from "@jumbo/hooks/useJumboSidebarTheme";
import { SIDEBAR_STYLES, SIDEBAR_VIEWS } from "@jumbo/utils/constants/layout";
import Logo from "../../../../shared/Logo";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import Zoom from "@mui/material/Zoom";
import Div from "@jumbo/shared/Div";
import SidebarSkeleton from "./SidebarSkeleton";
import homemenu from "./homemenu";
import settingmenus from "./settingmenu";
import adminhomemenu from "./user-admin-sidebars/homemenu";
import mailmenu from "./user-admin-sidebars/mailmenu";
import requestmenus from "./user-admin-sidebars/requestmenus";
import taskmanagementmenus from "./user-admin-sidebars/taskmanagementmenu";
import { adminHrmenus } from "./hrmenus";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchUserRolePermissions,
  selectedUserRolePermissions,
} from "app/redux/actions/fetchUserRolePermissions";
import {
  Tenantname,
  TENANTS_WITHOUT_REQUIRED_FIELD,
} from "app/services/auth-services";
import SidebarProfile from "./SidebarProfile";

const Sidebar = ({ sidebarOptions, showHRMenu, showSettingMenus }) => {
  const dispatch = useDispatch();
  const { userRolePermissions, formPermissions, modulePermissions } =
    useSelector(selectedUserRolePermissions);

  console.log("modulePermissions", modulePermissions, formPermissions);

  let userDetails = localStorage.getItem("UserDetails");
  userDetails = JSON.parse(userDetails);
  const userType = userDetails && userDetails.UserType;

  useEffect(() => {
    const token = localStorage.getItem("accesstoken");
    if (token) {
      dispatch(fetchUserRolePermissions(token));
    }
  }, [dispatch]);

  const getFilteredMenus = (menus) => {
    return menus
      ?.map((menu) => {
        // const permissions = (menu.type === 'collapsible' && menu.label.includes("Report"))
        //   ? modulePermissions
        //   : formPermissions;

        const permissions = formPermissions;

        if (menu.type === "collapsible") {
          const filteredChildren =
            menu.children
              ?.map((child) => {
                if (
                  child.type === "nav-item" &&
                  permissions.includes(child.id)
                ) {
                  return { ...child };
                } else if (child.type === "collapsible") {
                  const filteredNestedChildren = getFilteredMenus(
                    child.children,
                  );
                  if (filteredNestedChildren.length > 0) {
                    return { ...child, children: filteredNestedChildren };
                  }
                }
                return null;
              })
              .filter((child) => child !== null) || [];

          if (filteredChildren.length > 0) {
            return {
              ...menu,
              children: filteredChildren,
            };
          }
        } else if (menu.type === "nav-item" && permissions.includes(menu.id)) {
          return { ...menu };
        }
        return null;
      })
      .filter((menu) => menu !== null);
  };

  // const getFilteredMenus = (items) => {
  //   return items
  // };

  // user
  const filterAdminHrMenus = getFilteredMenus(adminHrmenus);
  const filterSettingMenus = getFilteredMenus(settingmenus);

  //----------------Useradmin-----------------------------//
  const filteradminmenu = adminhomemenu;
  const filtermailmenu = mailmenu;
  const filterrequestmenu = requestmenus;
  const filterticketmenu = taskmanagementmenus;
  const filtersettingmenu = settingmenus;

  const shouldSkip = () => {
    return TENANTS_WITHOUT_REQUIRED_FIELD.includes(Tenantname?.toLowerCase());
  };

  return (
    <React.Fragment>
      <SidebarHeader />

      {!shouldSkip() && <SidebarProfile />}

      <JumboScrollbar autoHide autoHideDuration={200} autoHideTimeout={500}>
        <Suspense
          fallback={
            <Div
              sx={{
                display: "flex",
                minWidth: 0,
                alignItems: "center",
                alignContent: "center",
                px: 3,
                zIndex: 1,
              }}
            >
              <SidebarSkeleton />
            </Div>
          }
        >
          {/* <Div sx={{ textAlign: "center", mt: 1, ml: 0 }}>
            <Typography variant="h4" color={"#7dcea0"}>{partnerName}</Typography>
          </Div> */}
          <br />
          {userType === "User" && (
            <>
              <JumboVerticalNavbar
                translate
                items={homemenu}
                style={{ display: sidebarOptions ? "block" : "none" }}
              />
              <JumboVerticalNavbar
                translate
                items={filterAdminHrMenus}
                style={{ display: showHRMenu ? "block" : "none" }}
              />
              {/* <JumboVerticalNavbar translate items={filterSettingMenus} style={{ display: showSettingMenus ? "block" : "none" }} /> */}
            </>
          )}

          {/* {userType === "UserAdmin" && ( */}
          {userType === "Corporate" && (
            <>
              <JumboVerticalNavbar translate items={filteradminmenu} />
              <JumboVerticalNavbar translate items={filtermailmenu} />
              <JumboVerticalNavbar translate items={filterrequestmenu} />
              {!shouldSkip({}) && (
                <JumboVerticalNavbar translate items={filterticketmenu} />
              )}
              <JumboVerticalNavbar translate items={filtersettingmenu} />
            </>
          )}
        </Suspense>
      </JumboScrollbar>
    </React.Fragment>
  );
};

const SidebarHeader = () => {
  let userDetails = localStorage.getItem("UserDetails");
  userDetails = JSON.parse(userDetails);

  const { sidebarOptions, setSidebarOptions } = useJumboLayoutSidebar();
  const { sidebarTheme } = useJumboSidebarTheme();

  const isMiniAndClosed = React.useMemo(() => {
    return sidebarOptions?.view === SIDEBAR_VIEWS.MINI && !sidebarOptions?.open;
  }, [sidebarOptions.open]);

  console.log("isMiniAndClosed", isMiniAndClosed);
  return (
    <React.Fragment>
      {sidebarOptions?.style !== SIDEBAR_STYLES.CLIPPED_UNDER_HEADER && (
        <DrawerHeader>
          <Logo
            mini={isMiniAndClosed}
            mode={sidebarTheme.type}
            sx={{
              margin: "8px 0px 0px 6px",
              borderRadius: "0%",
              "&:hover,&:active": {
                // Add custom styles if needed
              },
            }}
          />
          {sidebarOptions?.view !== SIDEBAR_VIEWS.FULL_HEIGHT && (
            <Zoom in={sidebarOptions?.open}>
              <IconButton
                edge="start"
                color="inherit"
                aria-label="open drawer"
                sx={{
                  ml: 0,
                  mr: -1.5,
                  fontSize: "2.5rem",
                  display: "flex",
                  alignItems: "center",
                  padding: "0px 20px",
                  margin: "-8px 0px 0px 10px",
                  borderRadius: "0%",
                  "&:hover,&:active": {
                    backgroundColor: "white",
                    color: "black",
                  },
                }}
                onClick={() => setSidebarOptions({ open: false })}
              >
                <div className="open-close-icon-theme3">
                  <MenuOpenIcon />
                </div>
              </IconButton>
            </Zoom>
          )}
        </DrawerHeader>
      )}
      {/* <Typography variant="h6" sx={{ p: 0, m: 0, textAlign: "center" }}>
        {userDetails?.UserType}
        {userDetails?.Designation}
      </Typography> */}
    </React.Fragment>
  );
};

export default Sidebar;
